var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "modal--search-widget modal--calendar",
      class: {
        "model-calendar--flexible-days-animate": _vm.flexibleDaysAnimate,
        "model-calendar--date-inputs-hidden": !_vm.showDateInputs
      },
      attrs: {
        title: _vm.translations.calendar_title,
        "close-on-click": true,
        "is-open": _vm.mounted,
        "no-scroll": _vm.enableNoscroll
      },
      on: { close: _vm.close }
    },
    [
      _c("img", {
        attrs: {
          slot: "icon",
          src: require("./../../../img/icons/icon-calendar.svg"),
          alt: ""
        },
        slot: "icon"
      }),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("data-range-picker", {
            ref: "rangepicker",
            attrs: {
              "min-date": _vm.minDate,
              showWeekNumbers: true,
              timePicker: false,
              ranges: false,
              localeData: _vm.localeData,
              flexibleStartDate: _vm.flexibleStartDate,
              flexibleEndDate: _vm.flexibleEndDate,
              autoApply: true,
              opens: _vm.opens
            },
            scopedSlots: _vm._u([
              {
                key: "input",
                fn: function(picker) {
                  return _vm.showDateInputs
                    ? _c(
                        "div",
                        { staticClass: "search-field search-dates" },
                        [
                          _c("input-field", {
                            attrs: {
                              name: "departure",
                              readonly: true,
                              "icon-type": "cal-start",
                              value: picker.startDate
                                ? _vm.formatDate(
                                    picker.startDate,
                                    "DD MMM",
                                    _vm.flexibleStartDays * -1
                                  )
                                : " "
                            }
                          }),
                          _vm._v(" "),
                          _c("input-field", {
                            attrs: {
                              name: "arrival",
                              readonly: true,
                              "icon-type": "cal-end",
                              value: picker.endDate
                                ? _vm.formatDate(
                                    picker.endDate,
                                    "DD MMM",
                                    _vm.flexibleEndDays
                                  )
                                : ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                }
              }
            ]),
            model: {
              value: _vm.dateRange,
              callback: function($$v) {
                _vm.dateRange = $$v
              },
              expression: "dateRange"
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "flexible-range-dropdowns" }, [
            _vm.startDate
              ? _c(
                  "div",
                  { staticClass: "from-date" },
                  [
                    _c("h2", {
                      domProps: {
                        textContent: _vm._s(
                          _vm.formatDate(_vm.startDate, "ddd D. MMM")
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("selector", {
                      attrs: {
                        options: _vm.startRange,
                        value: _vm.flexibleStartDays,
                        iconType: "drop-down"
                      },
                      on: {
                        input: function(val) {
                          return (_vm.flexibleStartDays = parseInt(val))
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.endDate
              ? _c(
                  "div",
                  { staticClass: "to-date" },
                  [
                    _c("h2", {
                      domProps: {
                        textContent: _vm._s(
                          _vm.formatDate(_vm.endDate, "ddd D. MMM")
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("selector", {
                      attrs: {
                        options: _vm.endRange,
                        value: _vm.flexibleEndDays,
                        iconType: "drop-down"
                      },
                      on: {
                        input: function(val) {
                          return (_vm.flexibleEndDays = parseInt(val))
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal-view__footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("button", {
            staticClass: "btn btn--success",
            attrs: { disabled: _vm.inSelection },
            domProps: { textContent: _vm._s(_vm.translations.ok_btn) },
            on: { click: _vm.close }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66889a33", { render: render, staticRenderFns: staticRenderFns })
  }
}